(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // QA: one comparable page-load block whether Malachyte is on or off.
  (() => {
    let lcp = null;
    try {
      new PerformanceObserver((list) => {
        const entries = list.getEntries();
        lcp = entries[entries.length - 1]?.startTime ?? lcp;
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch {
      // Not supported (Safari) — every other number still works.
    }

    const round = (value) => (value == null ? null : Math.round(value));

    const report = () => {
      const nav = performance.getEntriesByType('navigation')[0];
      // Scope to results-list: the cart upsell snippets also use [data-products-container].
      const container = document.querySelector('results-list [data-products-container]');
      const isOn = Boolean(document.querySelector('malachyte-plp'));
      const malachyte = window.__malachyteQA__ ?? null;

      const page = {
        'TTFB (ms)': round(nav?.responseStart),
        'HTML downloaded (ms)': round(nav?.responseEnd),
        'DOM interactive (ms)': round(nav?.domInteractive),
        'DOMContentLoaded (ms)': round(nav?.domContentLoadedEventEnd),
        'load (ms)': round(nav?.loadEventEnd),
        'LCP (ms)': round(lcp),
        'products in collection': Number(container?.dataset.productsCount ?? 0),
        'product cards in grid': document.querySelectorAll(
          'results-list [data-products-container] li[data-product-id]'
        ).length,
      };

      console.groupCollapsed(
        `[Malachyte QA] ${window.location.pathname} — Malachyte ${isOn ? 'ON' : 'OFF'} · LCP ${
          page['LCP (ms)'] ?? 'n/a'
        }ms · load ${page['load (ms)'] ?? 'n/a'}ms`
      );
      console.table(page);
      if (isOn && malachyte?.applied) {
        console.table(malachyte.timings);
        console.log(
          `Reordered ${malachyte.positionsChanged}/${malachyte.products} positions. ` +
            'Full order comparison is in the [Malachyte PLP] QA group above.'
        );
      } else if (isOn) {
        console.warn(
          'Malachyte is enabled but did not apply — Shopify order retained.',
          malachyte?.reason ?? '(see earlier warnings)'
        );
      }
      console.groupEnd();
    };

    // 1.5s after load gives the Malachyte flow time to report and LCP time to settle.
    if (document.readyState === 'complete') setTimeout(report, 1500);
    else window.addEventListener('load', () => setTimeout(report, 1500), { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
